export default function removeNumberKeys(obj) {
    const newObject = {};
    Object.keys(obj).forEach((key) => {
      if (isNaN(key)) {
        newObject[key] = obj[key];
      }
    });
    return newObject;
  }